<h1>Favourite Albums</h1>
<h3>Albums you have saved ({{favourites.count()}} / {{favourites.max}}). Click the heart on any album to save or remove it.</h3>

<div class="filters">
  <div class="search-row">
    <input type="search" class="search-box" placeholder="Search your favourite albums by title or artist"
      aria-label="Search your favourite albums" [value]="query()" (input)="setQuery($any($event.target).value)" />
    @if (query() || genre() >= 0 || sort() !== 'top' || year() !== 0) {
    <button type="button" class="filter-chip" (click)="clearFilters()">Clear filters</button>
    }
  </div>

  @if (genreOptions().length > 0) {
  <div class="chip-row" role="group" aria-label="Genre">
    @for (g of genreOptions(); track g.id) {
    <button type="button" class="filter-chip" [class.active]="g.id === genre()"
      [attr.aria-pressed]="g.id === genre()" (click)="selectGenre(g.id)">{{g.name}}</button>
    }
  </div>
  }

  <div class="chip-row control-row">
    <app-album-sort-controls [sort]="sort()" [year]="year()" [years]="years" [availableYears]="availableYears()"
      (sortChange)="setSort($event)" (yearChange)="setYear($event)" />
  </div>
</div>

@if (error()) {
<p class="status error">{{error()}}</p>
}

<div class="container">
  @if (!loading() && pool().length === 0 && !error()) {
  <p class="status">No favourite albums yet. Click the heart on any album on
    <a routerLink="/new-releases">Top Albums</a>, an artist page or an album page to save it here.</p>
  } @else {
  <app-album-grid [albums]="visible()" subtitle="Favourite Album"
    [favouriteIds]="favourites.ids()" (favouriteToggle)="toggleFavourite($event)" />

  @if (!loading() && visible().length === 0 && pool().length > 0) {
  <p class="status">No saved albums match these filters.</p>
  }

  <app-pager [page]="page()" [pages]="pages()" (pageChange)="setPage($event)" />
  @if (filtered().length > 0) {
  <p class="status count">{{filtered().length}} of {{pool().length}} albums &middot; page {{page()}} of {{pages()}}</p>
  }
  }
</div>
